import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { CompanyPoliciesOut } from './PoliciesTypes';
import { ErrorResponse } from '../ReduxTypes';
import { api } from '@utils/api';

export const getPoliciesOperation = createAsyncThunk<
  CompanyPoliciesOut[],
  void,
  { rejectValue: ErrorResponse }
>('policies/getPolicies', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get<CompanyPoliciesOut[]>('resources/policies', {});
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({
      message: e.response?.data?.message || e.response?.data?.detail || e.message,
    });
  }
});
